import React from 'react'
import useCustomStyles from '../../hooks/useCustomStyles'
import { accessCodesStyles } from '../../assets/styles/accessCodesStyles'
import { useDispatch, useSelector } from 'react-redux'
import { selectState } from '../../store/slices/themeSlice'
import CustomInput from '../../components/CustomInput'
import CustomSelect from '../../components/CustomSelectInput'
import { useFormik } from 'formik'
import { ContractFormType } from './contracts'
import { addContract } from '../../store/actions/accessCodeActions'
import { AppDispatch, RootState } from '../../store/store'
import CustomButton from '../../components/CustomButton'
import * as Yup from 'yup'

const NewContract: React.FC = () => {
  const { theme } = useSelector(selectState)
  const classes = useCustomStyles(accessCodesStyles, theme)
  const dispatch = useDispatch<AppDispatch>()
  const { businesses, loading } = useSelector(
    (state: RootState) => state.accessCode_slice,
  )

  const validationSchema = Yup.object({
    contract_ref: Yup.string().required('Contract reference is required'),
    business_client: Yup.string().required('Please select a business client'),
    useLimit: Yup.number()
      .required('Use limit is required')
      .min(1, 'Use limit must be at least 1'),
    expire_at: Yup.date().required('Expiry date is required'),
  })

  // Initialize Formik
  const formik = useFormik<ContractFormType>({
    initialValues: {
      business_client: '', // initial value for business client select
      contract_ref: '',
      useLimit: 1,
      expire_at: undefined,
      id: undefined,
    },
    validationSchema,
    onSubmit: (values) => {
      // Dispatch your code generation action here if needed
      // console.log("Form values from add new contract submit:", values);
      dispatch(addContract(values))
      // Reset form after submission
      formik.resetForm()
    },
  })
  // Wrapper function to handle form submission from button click
  const handleFormSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    formik.handleSubmit() // Trigger formik form submission
  }
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>Add New Contract</h2>
      </div>
      <div style={{ width: '50%' }}>
        <form onSubmit={formik.handleSubmit}>
          {/* Business Client Select */}
          <CustomSelect
            name="business_client"
            label=" Business Client"
            placeholder="Select Business"
            value={formik.values.business_client}
            options={
              businesses
                ? businesses.map((item) => {
                    return { name: item.name, id: item.id }
                  })
                : []
            }
            onChange={(e) =>
              formik.setFieldValue('business_client', e.target.value)
            }
            error={
              formik.errors.business_client && formik.touched.business_client
                ? formik.errors.business_client
                : ''
            }
          />

          {/* Contract Reference Input */}
          <CustomInput
            name="contract_ref"
            label="Contract Reference"
            type="text"
            value={formik.values.contract_ref}
            onChange={formik.handleChange}
            placeholder="Enter Contract Reference"
            error={formik.errors.contract_ref ? formik.errors.contract_ref : ''}
          />

          {/* Use Limit Input */}
          <CustomInput
            name="useLimit"
            label="Use Limit"
            type="number"
            value={formik.values.useLimit}
            onChange={formik.handleChange}
            placeholder="Entre Use Limit"
            error={formik.errors.useLimit ? formik.errors.useLimit : ''}
          />

          {/* Expiry Date Input */}
          <CustomInput
            name="expire_at"
            label="Expiry date"
            type="date"
            value={formik.values.expire_at}
            onChange={formik.handleChange}
            placeholder="Select Expiry date"
            error={formik.errors.expire_at ? formik.errors.expire_at : ''}
          />

          {/* Submit Button */}
          <CustomButton
            title="Add"
            name="generateAccessCode"
            disabled={!formik.isValid || loading || !formik.dirty}
            handleClick={handleFormSubmit} // Use wrapper for form submission
            loading={false}
          />
        </form>
      </div>
    </div>
  )
}
export default NewContract
